import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiMail, FiPhone, FiMapPin, FiClock } from 'react-icons/fi';
import { useModal } from '../services/ModalService';
import '../styles/pages/Contact.css';

const Contact = () => {
  const { openContactModal } = useModal();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    alert('Thank you for your message! We\'ll get back to you soon.');
  };

  return (
    <div className="contact">
      {/* Hero Section */}
      <section style={{
        minHeight: "60vh",
        display: "flex", 
        alignItems: "center",
        position: "relative",
        background: "linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(167, 85, 247, 0.1) 100%)",
        paddingTop: "120px"
      }}>
        <div className="contact-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{ textAlign: "center" }}
          >
            <div className="hero-badge">
              📞 Get In Touch
            </div>
            
            <h1 className="hero-title"
            dangerouslySetInnerHTML={{ __html: "Ready to <span class=\"gradient-text\">Transform</span><br />Your Business?" }}
            />
            
            <p className="hero-subtitle">
              Ready to transform your business? Let's discuss how we can help you achieve your goals
            </p>
            
            <div className="hero-buttons">
              <button 
                className="btn-primary"
                onClick={() => openContactModal(
                  'General Inquiry',
                  'Contact Page - Start the Conversation'
                )}
              >
                Start the Conversation
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Contact Information & Form Section */}
      <section className="contact-section">
        <div className="contact-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <p className="contact-section-subtitle">
              Multiple ways to connect with our expert team
            </p>
            
            <div className="contact-services-grid">
              {/* Contact Information */}
              <div className="contact-glass-card">
                <h3>Contact Information</h3>
                
                <div className="contact-info-list">
                  <div className="contact-info-item">
                    <FiMail className="contact-info-icon" />
                    <div>
                      <h4 className="contact-info-label">Email</h4>
                      <p>support@rkubeinc.com</p>
                    </div>
                  </div>
                  
                  <div className="contact-info-item">
                    <FiPhone className="contact-info-icon" />
                    <div>
                      <h4 className="contact-info-label">Phone</h4>
                      <p>(984) 234-7007</p>
                    </div>
                  </div>
                  
                  <div className="contact-info-item">
                    <FiMapPin className="contact-info-icon" />
                    <div>
                      <h4 className="contact-info-label">Address</h4>
                      <p>4030 Wake Forest Road, STE 349<br />Raleigh, NC, 27609, USA</p>
                    </div>
                  </div>
                  
                  <div className="contact-info-item">
                    <FiClock className="contact-info-icon" />
                    <div>
                      <h4 className="contact-info-label">Business Hours</h4>
                      <p>Monday - Friday: 9:00 AM - 6:00 PM<br />Saturday: 10:00 AM - 4:00 PM</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div className="contact-glass-card">
                <h3>Send us a Message</h3>
                
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="contact-form-row">
                    <div>
                      <label className="contact-form-label">Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="contact-form-input"
                      />
                    </div>
                    
                    <div>
                      <label className="contact-form-label">Email *</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="contact-form-input"
                      />
                    </div>
                  </div>
                  
                  <div className="contact-form-group">
                    <label className="contact-form-label">Company</label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="contact-form-input"
                    />
                  </div>
                  
                  <div className="contact-form-group">
                    <label className="contact-form-label">Service of Interest</label>
                    <select
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      className="contact-form-input"
                    >
                      <option value="">Select a service</option>
                      <option value="financial">Financial Services</option>
                      <option value="it-solutions">IT Solutions</option>
                      <option value="staffing">Staffing</option>
                      <option value="consultation">General Consultation</option>
                    </select>
                  </div>
                  
                  <div className="contact-form-submit">
                    <label className="contact-form-label">Message *</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      className="contact-form-textarea"
                    />
                  </div>
                  
                  <button type="submit" className="btn-primary contact-submit-button">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Contact; 